import Step from 'Shared/components/Builder/Step'
import { useAct } from 'DashboardBuilder/store'

export default function DashboardBuilderStep ({
  children,
  onDiscardChanges,
  editor,
  save,
  ...rest
}) {

  const act = useAct()
  const dashboardId = useSel(s => s.dashboard.id)
  const { currentEditor } = useSel(s => s.builder)

  const open = () => {
    act.builder.openEditor(editor)
  }

  const close = () => {
    if (onDiscardChanges) {
      onDiscardChanges()
    } else {
      act.builder.reload(dashboardId)
    }
    act.builder.closeEditor()
  }

  return (
    <Step
      {...rest}
      open={open}
      save={save}
      close={close}
      editor={editor}
      currentEditor={currentEditor}
      >
      {children}
    </Step>
  )
}
